import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_INTERNAL_NOTES_REQUEST = 'FETCH_INTERNAL_NOTES_REQUEST';
export const FETCH_INTERNAL_NOTES_SUCCESS = 'FETCH_INTERNAL_NOTES_SUCCESS';
export const FETCH_INTERNAL_NOTES_FAILURE = 'FETCH_INTERNAL_NOTES_FAILURE';
export const ADD_INTERNAL_NOTE_REQUEST = 'ADD_INTERNAL_NOTE_REQUEST';
export const ADD_INTERNAL_NOTE_SUCCESS = 'ADD_INTERNAL_NOTE_SUCCESS';
export const ADD_INTERNAL_NOTE_FAILURE = 'ADD_INTERNAL_NOTE_FAILURE';
export const EDIT_INTERNAL_NOTE_REQUEST = 'EDIT_INTERNAL_NOTE_REQUEST';
export const EDIT_INTERNAL_NOTE_SUCCESS = 'EDIT_INTERNAL_NOTE_SUCCESS';
export const EDIT_INTERNAL_NOTE_FAILURE = 'EDIT_INTERNAL_NOTE_FAILURE';
export const DELETE_INTERNAL_NOTE = 'DELETE_INTERNAL_NOTE';
export const DELETE_INTERNAL_NOTE_REQUEST = 'DELETE_INTERNAL_NOTE_REQUEST';
export const DELETE_INTERNAL_NOTE_SUCCESS = 'DELETE_INTERNAL_NOTE_SUCCESS';
export const DELETE_INTERNAL_NOTE_FAILURE = 'DELETE_INTERNAL_NOTE_FAILURE';

const buildFetchInternalNotesUrl = (sessionPlanId, extra = '') =>
  buildUrl(`/sessions/${sessionPlanId}/notes${extra}`);

export function fetchInternalNotesIfNeeded(sessionPlanId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchInternalNotesUrl(sessionPlanId) })) {
      return false;
    }

    return dispatch(fetchInternalNotes(sessionPlanId));
  };
}

export function fetchInternalNotes(sessionPlanId) {
  return (dispatch) => {
    const url = buildFetchInternalNotesUrl(sessionPlanId);
    const method = 'GET';

    return dispatch(fetchInternalNotesRequest()).payload
      .then((response) => dispatch(fetchInternalNotesSuccess(response)))
      .catch((error) => dispatch(fetchInternalNotesFailure(error)));

    function fetchInternalNotesRequest() {
      return ApiCall.createAction({
        type: FETCH_INTERNAL_NOTES_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionPlanId,
      });
    }

    function fetchInternalNotesSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_INTERNAL_NOTES_SUCCESS,
        payload: response,
        url,
        method,
        sessionPlanId,
      });
    }

    function fetchInternalNotesFailure(error) {
      return ApiCall.createAction({
        type: FETCH_INTERNAL_NOTES_FAILURE,
        error,
        url,
        method,
        sessionPlanId,
      });
    }
  };
}

export function addInternalNote(sessionPlanId, internalNote) {
  return (dispatch) => {
    const url = buildFetchInternalNotesUrl(sessionPlanId);
    const method = 'POST';

    return dispatch(addInternalNoteRequest()).payload
      .then((response) => dispatch(addInternalNoteSuccess(response)))
      .then(() => dispatch(fetchInternalNotes(sessionPlanId)))
      .catch((error) => dispatch(addInternalNoteFailure(error)));

    function addInternalNoteRequest() {
      const param = {
        method,
        body: JSON.stringify(internalNote),
      };
      return ApiCall.createAction({
        type: ADD_INTERNAL_NOTE_REQUEST,
        payload: fetch(url, param),
        url,
        method,
        sessionPlanId,
      });
    }

    function addInternalNoteSuccess(response) {
      return ApiCall.createAction({
        type: ADD_INTERNAL_NOTE_SUCCESS,
        payload: response,
        url,
        method,
        sessionPlanId,
      });
    }

    function addInternalNoteFailure(error) {
      return ApiCall.createAction({
        type: ADD_INTERNAL_NOTE_FAILURE,
        error,
        url,
        method,
        sessionPlanId,
      });
    }
  };
}

export function editInternalNote(sessionPlanId, index, internalNote) {
  return (dispatch) => {
    const url = buildFetchInternalNotesUrl(sessionPlanId, `/${internalNote.noteId}`);
    const method = 'PUT';

    return dispatch(editInternalNoteRequest()).payload
      .then((response) => dispatch(editInternalNoteSuccess(response)))
      .catch((error) => dispatch(editInternalNoteFailure(error)))
      .then(() => dispatch(fetchInternalNotes(sessionPlanId)));

    function editInternalNoteRequest() {
      const param = {
        method,
        body: JSON.stringify(internalNote),
      };
      return ApiCall.createAction({
        type: EDIT_INTERNAL_NOTE_REQUEST,
        payload: fetch(url, param),
        url,
        method,
        sessionPlanId,
      });
    }

    function editInternalNoteSuccess(response) {
      return ApiCall.createAction({
        type: EDIT_INTERNAL_NOTE_SUCCESS,
        payload: response,
        url,
        method,
        sessionPlanId,
        index,
        internalNote,
      });
    }

    function editInternalNoteFailure(error) {
      return ApiCall.createAction({
        type: EDIT_INTERNAL_NOTE_FAILURE,
        error,
        url,
        method,
        sessionPlanId,
      });
    }
  };
}

export function deleteInternalNote(sessionPlanId, index, internalNote) {
  return {
    type: DELETE_INTERNAL_NOTE,
    sessionPlanId,
    index,
    internalNote,
  };
}

export function deleteInternalNoteFromServer(sessionPlanId, { noteId }) {
  return (dispatch) => {
    const url = buildFetchInternalNotesUrl(sessionPlanId, `/${noteId}`);
    const method = 'DELETE';

    return dispatch(deleteInternalNoteRequest()).payload
      .then((response) => dispatch(deleteInternalNoteSuccess(response)))
      .catch((error) => dispatch(deleteInternalNoteFailure(error)));

    function deleteInternalNoteRequest() {
      return ApiCall.createAction({
        type: DELETE_INTERNAL_NOTE_REQUEST,
        payload: fetch(url, { method }),
        url,
        method,
        sessionPlanId,
      });
    }

    function deleteInternalNoteSuccess(response) {
      return ApiCall.createAction({
        type: DELETE_INTERNAL_NOTE_SUCCESS,
        payload: response,
        url,
        method,
        sessionPlanId,
      });
    }

    function deleteInternalNoteFailure(error) {
      return ApiCall.createAction({
        type: DELETE_INTERNAL_NOTE_FAILURE,
        error,
        url,
        method,
        sessionPlanId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/InternalNotes/actions.js